import React from "react";
import {
    createShoppingCard, deleteShoppingCard,
    fetchShoppingCardByVisitorRelID,
    removeItemFromShoppingCard
} from "../reduxLib/shoppingcardLib";
import store from "../store";
import {fetchVisitorByUUID} from "../reduxLib/visitorLib";


function productCardIni()
{
    const initialCard={
        productIds:[],
        OrderCreation:false,
        orderIdRel:null,
        Total:0,
        NumProd:0,
        UserIdRel:null,
        VisitorIdRel:null
    }


    let productCard= localStorage.getItem("productCard");
    let exp = Number(localStorage.getItem("productCard_exp"));

    if (!productCard || !exp || Date.now() > exp) {
        productCard = JSON.stringify([]);
        localStorage.setItem("productCard", productCard);
        //initialCard.VisitorIdRel=playload.visitorID;
        localStorage.setItem("productCard_exp", Date.now() + 24 * 60 * 60 * 1000);
         store
            .dispatch(fetchVisitorByUUID(localStorage.getItem("vid")))
            .unwrap()
            .then(visitor => {
                console.log("fetch UUID visitor:", visitor);

                const cardToCreate = {
                    ...initialCard,
                    VisitorIdRel: visitor.visitorID, // <- τώρα είναι σωστό
                };

                return store.dispatch(createShoppingCard(cardToCreate)).unwrap();
            })
            .then(card => {
                console.log("createShoppingCard:", card);
                // αν θες:
                // localStorage.setItem("shoppingCardId", String(card.shoppingCardId));
                return [];
            })
            .catch(err => {
                console.error("productCardIni error:", err);
                return [];
            });
        return [];
    }
    // safe parse
    try {
        return JSON.parse(productCard);
    } catch {
        localStorage.removeItem("productCard");
        localStorage.removeItem("productCard_exp");
        //get visitor uui and id and delete related shopping card.

        store
            .dispatch(fetchVisitorByUUID(localStorage.getItem("vid")))
            .unwrap()
            .then(visitor => {
                console.log("Visitor:", visitor);
                return store
                    .dispatch(fetchShoppingCardByVisitorRelID(visitor.visitorID))
                    .unwrap();
            })
            .then(shoppingCard => {
                console.log("ShoppingCard:", shoppingCard);
                return store
                    .dispatch(
                        deleteShoppingCard(shoppingCard.shoppingCardId)
                    )
                    .unwrap();
            })
            .then(result => {
                console.log("AddItem result:", result);
            })
            .catch(err => {
                console.error("ERROR:", err);
            });

        return [];
    }

    return JSON.parse(productCard);
}
export default productCardIni;